import * as React from 'react';

import type { HiveClient, HiveGlobalPresence } from '@gitbook/hive-client';

export const HiveContext = React.createContext<HiveClient | null>(null);

export const HiveGlobalPresenceContext = React.createContext<HiveGlobalPresence | null>(null);
